import { Pipe, PipeTransform } from '@angular/core';

/**
 * filters an array based on searctext
 */
@Pipe({
    name: 'filterByFields',
    standalone: false
})
export class FilterByFieldsPipe implements PipeTransform {
    public transform(array: any[], searchText?: string, keyNames?: string[]) {
        if (!array || !searchText || typeof searchText !== 'string' || !Array.isArray(array) || !keyNames || !Array.isArray(keyNames)) {
            return array;
        }
        return array.filter((item: any) => 
            keyNames.reduce((str, key) => `${str}${item[key]}`,'').toLowerCase().replace(/\s+/g, '').replace('-','')
            .includes(searchText.toLowerCase().replace(/\s+/g, '').replace('-','')));
    }
}
